module.exports = __webpack_public_path__ + "img/Belgium.e74ff201.png";